import { useEffect, useState } from 'react'

//Store
import { useSelector } from 'react-redux'
import { RootState } from '../../redux/store'

//Components
import EventLogo from '../../components/EventLogo'
import PhoneVerification from './PhoneVerification'
import OTPVerification from './OtpVerification'
import UserDetails from './UserDetails'
import Landing from './Landing'

//Animations
import { useTransition, animated } from 'react-spring'
import { ViewTypes } from '../../types/state'
import { Width, Wrapper } from './styles'

const Login = () => {
	const [isLoaded, setIsLoaded] = useState(false)
	const [whatsAppChecked, setWhatsAppChecked] = useState(true)
	const transition = useTransition(isLoaded, {
		from: { opacity: 0, transform: 'translateX(-20px)', delay: 100 },
		enter: { opacity: 1, transform: 'translateX(0)', delay: 100 },
		leave: { opacity: 0, transform: 'translateX(20px)', delay: 100 },
	})
	const metaData = useSelector((state: RootState) => state.meta)
	useEffect(() => {
		if (metaData.view !== ViewTypes.LANDING) {
			setIsLoaded(true)
		}
	}, [metaData.view])

	const whatsAppCheck = () => {
		if (whatsAppChecked) {
			setWhatsAppChecked(false)
		} else {
			setWhatsAppChecked(true)
		}
	}

	return (
		<Wrapper>
			{transition((style, item) =>
				item ? (
					<Width>
						{metaData.view !== ViewTypes.LANDING && (
							<>
								<animated.div style={style}>
									<EventLogo />
								</animated.div>
								{metaData.view === ViewTypes.LOGIN && (
									<PhoneVerification
										whatsAppCheck={whatsAppCheck}
										whatsAppChecked={whatsAppChecked}
									/>
								)}
								{metaData.view === ViewTypes.OTP && (
									<OTPVerification whatsAppChecked={whatsAppChecked} />
								)}
								{metaData.view === ViewTypes.USER_INFO && (
									<UserDetails />
								)}
							</>
						)}
					</Width>
				) : (
					''
				)
			)}
			{metaData.view === ViewTypes.LANDING && (
				<Width>
					<Landing />
				</Width>
			)}
		</Wrapper>
	)
}

export default Login
